import { useState, useEffect } from "react";
import { cambiarFormulario, datosConsultarHistorial, duplicate, tiempo } from "infortech_modules/Constantes/Constantes";
import Get from "infortech_modules/Crud/Get";
import Contenedor from "infortech_modules/Componentes/Contenedor";
import Permisos, { Autorizado } from "infortech_modules/Constantes/Usuarios";
import { CreaarFila } from "infortech_modules/Constantes/CrearTabla";
import ModalAdd from "infortech_modules/Modales/ModalAdd";
import CrearInput from "infortech_modules/Constantes/CrearInput";
import ModalEdit from "infortech_modules/Modales/ModalEdit";
import ModalDelete from "infortech_modules/Modales/ModalDelete";


export default function Zonas({iniciar}) {
    const [cargar, setCargar] = useState(true);
    const [error, setError] = useState(false);
    const [mensaje, setMensaje] = useState('Error');
    const [data, setData] = useState([]);
    const [agregar, setAgregar] = useState({zona:''})
    const [editar, setEditar] = useState({id:'', zona:''})

    useEffect(() => {
        principal();
        // eslint-disable-next-line
    }, [])

    const principal = (est) => {
        est && setCargar(true);
        Get({ url: '/get', key: '4', iniciar:iniciar }).then((r) => {
            setData(r);            
            tiempo(500, setCargar, false)
        }).catch((f) => {
            setMensaje(f);
            tiempo(500, setError, true, setCargar, false);
        })
    }

    const formAdd = [
        [CrearInput({type:'text', name:'zona', value:agregar.zona, placeholder:'Zonas'})]
    ]

    const formEditar = [
        [CrearInput({type:'text', name:'zona', value:editar.zona, placeholder:'Zonas'})]
    ]

    return (
        <>
        <Contenedor rutas={['Inicio', 'Configuraciones', 'Zonas']} autorizado={Permisos().zonas}
        cargar={cargar} mensajeCarga={'Por favor espere...'} classNameMensaje={'text-dark fs-4 fw-bold fcom'} altura={'85vh'}
        error={error} mensajeError={mensaje} claseNameTextError={'text-danger fs-4 fw-bold fcom'}
        titulo={'Zonas'}
        botonAdd = {Autorizado([Permisos().actividadesAdd]) && 
        <ModalAdd
        tipoBotonPrincipal={'principal'} tituloBotonPrincipal={'Nueva Zona'} 
        modalTitulo={'Registrar Nueva Zona'} tituloBotonEnviar={'Registrar'} tipoBotonEnviar={'principal'}
        formulario={formAdd} onChange={(e) => cambiarFormulario(e, agregar, setAgregar)}
        url={'/post'} tabla={'zonas'} caso={'zonasAdd'} agregar={agregar} duplicados={duplicate(true, [agregar.zona], ['zona'], ['Esta zona ya esta registrada'])}
        mensajeLoadingPromesa={'Registrando...'} mensajePromesa={'Zona Registrada'} comprobarTextoVacio={[agregar.zona]} 
        mensajeTextoVacio={['Digite una Zona']} infoLog={agregar.zona} principal={principal}
         />
        } 
        tablaEncabezado={['Item','Zona', 'Acción']} claseTablaEncabezado={'text-center'} tablaNombre={'tac'}
        tablaFilas={data.map((v,i) => {
            return (
                <tr key={i}>
                    {
                        CreaarFila([i+1, v.zona], "scope", [""], "text-center")
                    }
                    <td className="text-center">
                        <ModalEdit
                        formulario={formEditar} onChange={(e) => cambiarFormulario(e, editar, setEditar) }
                        modalTitulo={'Editar'} inicializarDatos={() => setEditar({id:v.id, zona:v.zona})}
                        duplicados={duplicate(true,[editar.zona],['zona'],['Esta zona ya esta registrada'], [`and id != '${v.id}'`])}
                        comprobarTextoVacio={[editar.zona]} mensajeTextoVacio={['"Digite el nombre de la Zona']}
                        mensajeLoadingPromesa={'Actualizando Datos...'} mensajePromesa={'Zona Editada'}
                        idLog={v.id} infoLog={`${v.zona} -> ${editar.zona} `}
                        url={'/put'} caso={'zonasEdit'} id={`id = ${v.id}`} tabla={'zonas'} editar={editar}
                        principal={principal}
                        />
                        &nbsp; &nbsp;
                        <ModalDelete
                        modalTitulo={'Eliminar Registro'} modalSize={'lg'}
                        mensajeEliminar={<>¿Seguro desea eliminar la zona <strong>{v.actividad}</strong>? </>}
                        consultarHistorial={datosConsultarHistorial(false,['clientes'],['zona'],['Error: Hay clientes asociadas con esta zona'])}
                        valorEliminar={v.id} infoLog={v.zona} caso={'zonasDel'}
                        url={'/del'} tabla={'zonas'} condicionEliminar={`id = ${v.id}`} principal={principal}            
                        mensajeLoadingPromesa={'Elimiando...'} mensajePromesa={'Eliminado'}

                        />
                    </td>
                </tr>
            )
        })}
        
        />
        </>
    )
};
